/**
 * @generated SignedSource<<eece35aa07385d739e1f6212cf239b97>>
 * @relayHash c64eff3bdc2352e89d29fc9d40e39f79
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255

import type { ConcreteRequest } from 'relay-runtime';
export type ExternalContentMediaSessionQuery$variables = {
  shareToken: string;
};
export type ExternalContentMediaSessionQuery$data = {
  readonly externalContentMediaSession: {
    readonly accessTokens: {
      readonly readOnlyToken: {
        readonly value: string;
      } | null | undefined;
      readonly readWriteToken: {
        readonly value: string;
      } | null | undefined;
    };
    readonly configuration: {
      readonly clientId: string;
      readonly fileStoreUrl: string;
    };
  } | null | undefined;
};
export type ExternalContentMediaSessionQuery = {
  response: ExternalContentMediaSessionQuery$data;
  variables: ExternalContentMediaSessionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shareToken"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "shareToken",
        "variableName": "shareToken"
      }
    ],
    "concreteType": "ContentMediaSession",
    "kind": "LinkedField",
    "name": "externalContentMediaSession",
    "plural": false,
    "selections": [
      {
        "concreteType": "MediaAccessTokens",
        "kind": "LinkedField",
        "name": "accessTokens",
        "plural": false,
        "selections": [
          {
            "concreteType": "MediaToken",
            "kind": "LinkedField",
            "name": "readOnlyToken",
            "plural": false,
            "selections": (v1/*: any*/)
          },
          {
            "concreteType": "MediaToken",
            "kind": "LinkedField",
            "name": "readWriteToken",
            "plural": false,
            "selections": (v1/*: any*/)
          }
        ]
      },
      {
        "concreteType": "MediaConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "fileStoreUrl"
          },
          {
            "kind": "ScalarField",
            "name": "clientId"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ExternalContentMediaSessionQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalContentMediaSessionQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c64eff3bdc2352e89d29fc9d40e39f79",
    "id": "0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255",
    "metadata": {},
    "name": "ExternalContentMediaSessionQuery",
    "operationKind": "query",
    "text": "query ExternalContentMediaSessionQuery($shareToken:String!){externalContentMediaSession(shareToken:$shareToken){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl,clientId}}}"
  }
};
})();

(node as any).hash = "73d645a33a55cbb7625d57b6d5cf2a1a";

export default node;
